import React, {useEffect, useState} from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from "./components/Card";

const App = ({dealId}) => {

    return (
        <>
            <Card dealId={dealId}/>
        </>
    )
}

export default App;
